import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 43 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F8BF08",
      "fill-rule": "evenodd",
      d: "M43 2.424a2.434 2.434 0 0 1-2.443 2.424H2.443A2.434 2.434 0 0 1 0 2.424 2.434 2.434 0 0 1 2.443 0h38.114A2.434 2.434 0 0 1 43 2.424M43 9.212a2.434 2.434 0 0 1-2.443 2.424H2.443A2.434 2.434 0 0 1 0 9.212a2.434 2.434 0 0 1 2.443-2.424h38.114A2.434 2.434 0 0 1 43 9.212M43 16a2.434 2.434 0 0 1-2.443 2.424H2.443A2.434 2.434 0 0 1 0 16a2.434 2.434 0 0 1 2.443-2.424h38.114A2.434 2.434 0 0 1 43 16M43 22.788a2.434 2.434 0 0 1-2.443 2.424H2.443A2.434 2.434 0 0 1 0 22.788a2.434 2.434 0 0 1 2.443-2.424h38.114A2.434 2.434 0 0 1 43 22.788M43 29.576A2.434 2.434 0 0 1 40.557 32H2.443A2.434 2.434 0 0 1 0 29.576a2.434 2.434 0 0 1 2.443-2.425h38.114A2.434 2.434 0 0 1 43 29.577",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }